import * as React from 'react';
import { Contract, Tree, User } from 'tree-wallet-client';
import TreeCounter from "../Component/Page/TreeCounter";
import { isImpersonating } from "../Service/RoleService";

export enum ConnectionState {
  online,
  offline
}

interface GlobalContextProps {
  navigate?: any,
  params?: any,
  location?: any,
  user?: User;
  contract?: Contract;
  contracts?: Contract[];
  trees?: Tree[];
  treeCount?: number;
  forceUpdate?: any;
  onlineStatus?: ConnectionState;
  counterRef: React.Ref<TreeCounter> | undefined;
  updateTrees?: Function;
  updateState?: Function;
  featureFlags?: any;
  impersonating: boolean;
  filter?: any;
}


const initialProps: GlobalContextProps = {
  navigate: undefined,
  params: undefined,
  location: undefined,
  user: undefined,
  contract: undefined,
  trees: undefined,
  treeCount: undefined,
  forceUpdate: undefined,
  featureFlags: undefined,
  contracts: undefined,
  counterRef: undefined,
  impersonating: isImpersonating(),
  onlineStatus: ConnectionState.online,
  updateTrees: () => { },
  updateState: () => { },
  filter: undefined,
};

export const GlobalContext = React.createContext<GlobalContextProps>(initialProps);
